import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import OrderTabs from 'pages/ipu/OrderTabs';

const SubmittedOrdersModal = ({ open, setOpen, state, setState }) => (
  <Dialog fullWidth={true} maxWidth="lg" open={open} onClose={setOpen}>
    <DialogTitle>Saved Orders</DialogTitle>
    <DialogContent>
      <DialogContentText>
        <OrderTabs state={state} setState={setState} />
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={setOpen} color="primary">
        Close
      </Button>
    </DialogActions>
  </Dialog>
);

export default SubmittedOrdersModal;
